<template>
  <div class="news-center">
    <!-- banner区域 -->
    <div class="banner">
      <h1>{{ $t('nav.news') }}</h1>
    </div>

          <!-- 新闻列表 -->
      <div class="news-list">
        <div v-for="(item, index) in newsList" :key="index" class="news-item">
          <div class="news-content">
            <img :src="item.image" :alt="item.title" v-if="item.image" />
            <div class="news-info">
              <h2>{{ item.title }}</h2>
              <p v-if="item.description">{{ item.description }}</p>
              <span class="date">{{ item.date }}</span>
              <div style="margin-top: 10px;">
                <a @click="toggleExpand(index)" class="read-more" style="cursor: pointer;">
                  {{ expandedItems[index] ? '隐藏全文' : '阅读全文' }}
                </a>
              </div>
            </div>
          </div>
          <!-- 展开的完整内容 -->
          <div v-if="expandedItems[index]" class="expanded-content">
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>

    <CallMe />
    <MobileCallme class="mobile-callme"></MobileCallme>
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: { CallMe, MobileCallme },
  data() {
    return {
      expandedItems: {}
    }
  },
  computed: {
    newsList() {
      // 直接从i18n本地获取资讯内容
      const info = this.$t('newsCenterInfo');
      // 将对象转换为数组格式
      if (!info || typeof info !== 'object') return [];
      
      // 将对象转换为数组格式，每个键作为一个新闻项
      return Object.keys(info).map((key, index) => {
        const item = info[key];
        // 根据索引选择不同的默认图片
        const defaultImage = index === 0 
          ? require('../../assets/img/hly/new2/news-1.png')
          : require('../../assets/img/hly/new2/news-2.png');
        
        return {
          title: item.title || key,
          description: item.background?.content || item.description || '',
          date: new Date().toLocaleDateString(), // 使用当前日期作为默认日期
          image: item.image || defaultImage, // 使用对应的默认图片
          content: this.formatContent(item)
        };
      });
    }
  },
  methods: {
    toggleExpand(index) {
      this.$set(this.expandedItems, index, !this.expandedItems[index]);
    },
    formatContent(item) {
      let content = '';
      
      // 格式化背景内容
      if (item.background) {
        content += `<h2>${item.background.title}</h2>`;
        content += `<p>${item.background.content}</p>`;
      }
      
      // 格式化业务背景内容
      if (item.businessBackground) {
        content += `<h2>${item.businessBackground.title}</h2>`;
        content += `<p>${item.businessBackground.content}</p>`;
      }
      
      // 格式化标准概述内容
      if (item.standardOverview) {
        content += `<h2>${item.standardOverview.title}</h2>`;
        content += `<p>${item.standardOverview.content}</p>`;
      }
      
      // 格式化好处内容
      if (item.benefits) {
        content += `<h2>${item.benefits.title}</h2>`;
        if (item.benefits.items) {
          content += '<ul>';
          item.benefits.items.forEach(benefit => {
            content += `<li>${benefit}</li>`;
          });
          content += '</ul>';
        }
      }
      
      // 格式化实施流程内容
      if (item.implementationProcess) {
        content += `<h2>${item.implementationProcess.title}</h2>`;
        if (item.implementationProcess.items) {
          content += '<ol>';
          item.implementationProcess.items.forEach((step, index) => {
            content += `<li>${step}</li>`;
          });
          content += '</ol>';
        }
      }
      
      // 格式化评级结果内容
      if (item.ratingResults) {
        content += `<h2>${item.ratingResults.title}</h2>`;
        content += `<p>${item.ratingResults.content}</p>`;
      }
      
      // 格式化评级周期内容
      if (item.ratingCycle) {
        content += `<h2>${item.ratingCycle.title}</h2>`;
        content += `<p>${item.ratingCycle.content}</p>`;
      }
      
      // 格式化服务益处内容
      if (item.serviceBenefits) {
        content += `<h2>${item.serviceBenefits.title}</h2>`;
        if (item.serviceBenefits.items) {
          content += '<ul>';
          item.serviceBenefits.items.forEach(benefit => {
            content += `<li>${benefit}</li>`;
          });
          content += '</ul>';
        }
      }
      
      // 格式化CBAM介绍内容
      if (item.cbamIntro) {
        content += `<h2>${item.cbamIntro.title}</h2>`;
        
        if (item.cbamIntro.whatIs) {
          content += `<h4>${item.cbamIntro.whatIs.title}</h4>`;
          content += `<p>${item.cbamIntro.whatIs.content}</p>`;
        }
        
        if (item.cbamIntro.industries) {
          content += `<h4>${item.cbamIntro.industries.title}</h4>`;
          content += `<p>${item.cbamIntro.industries.content}</p>`;
          // 在涵盖行业内容后添加news-1-1图片
          content += `<div style="text-align: center; margin: 20px 0;"><img src="${require('../../assets/img/hly/new2/news-1-1.png')}" alt="行业涵盖" style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"></div>`;
        }
        
        if (item.cbamIntro.reporting) {
          content += `<h4>${item.cbamIntro.reporting.title}</h4>`;
          content += `<p>${item.cbamIntro.reporting.content}</p>`;
        }
        
        if (item.cbamIntro.exporterObligations) {
          content += `<h4>${item.cbamIntro.exporterObligations.title}</h4>`;
          content += `<p>${item.cbamIntro.exporterObligations.content}</p>`;
        }
      }
      
      // 格式化实施内容
      if (item.implementation) {
        content += `<h2>${item.implementation.title}</h2>`;
        content += `<p>${item.implementation.content}</p>`;
        if (item.implementation.periods) {
          content += '<ul>';
          item.implementation.periods.forEach(period => {
            content += `<li>${period}</li>`;
          });
          content += '</ul>';
        }
      }
      
      // 格式化报告方法内容
      if (item.reportingMethod) {
        content += `<h2>${item.reportingMethod.title}</h2>`;
        content += `<p>${item.reportingMethod.content}</p>`;
        // 在报告方法内容后添加news-1-2图片
        content += `<div style="text-align: center; margin: 20px 0;"><img src="${require('../../assets/img/hly/new2/news-1-2.png')}" alt="报告方法" style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"></div>`;
      }
      
      // 格式化证书内容
      if (item.certificates) {
        content += `<h2>${item.certificates.title}</h2>`;
        if (item.certificates.details) {
          content += '<ul>';
          item.certificates.details.forEach(detail => {
            content += `<li>${detail}</li>`;
          });
          content += '</ul>';
        }
      }
      
      // 格式化服务内容
      if (item.services) {
        content += `<h2>${item.services.title}</h2>`;
        // 在服务标题后添加news-1-3图片
        content += `<div style="text-align: center; margin: 20px 0;"><img src="${require('../../assets/img/hly/new2/news-1-3.png')}" alt="服务介绍" style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"></div>`;
        content += `<h4>${item.services.subtitle}</h4>`;
        
        if (item.services.ourServices) {
          content += `<h4>> ${item.services.ourServices.title}</h4>`;
          if (item.services.ourServices.items) {
            content += '<ul>';
            item.services.ourServices.items.forEach(service => {
              content += `<li>${service}</li>`;
            });
            content += '</ul>';
          }
        }
        
        if (item.services.ourAdvantages) {
          content += `<h4>> ${item.services.ourAdvantages.title}</h4>`;
          if (item.services.ourAdvantages.technical) {
            content += `<h5>● ${item.services.ourAdvantages.technical.title}</h5>`;
            content += `<p>${item.services.ourAdvantages.technical.content}</p>`;
          }
          if (item.services.ourAdvantages.team) {
            content += `<h5>● ${item.services.ourAdvantages.team.title}</h5>`;
            content += `<p>${item.services.ourAdvantages.team.content}</p>`;
          }
        }
      }
      
      return content || '<p>暂无详细内容</p>';
    }
  }
}
</script>

<style>
.news-center {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.banner {
  height: 700px;
  background-image: url('../../assets/img/hly/new/关于我们/资讯中心.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
}

.banner h1 {
  font-size: 48px;
}

@media screen and (max-width: 768px) {
  .banner {
    height: 300px;
  }
  .banner h1 {
    font-size: 24px;
  }
}

.news-list {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 15px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    padding: 1rem;
  }
}

.news-item {
  background: white;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 6px;
  transition: all 0.3s;
}

.news-item:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.news-content {
  display: flex;
  gap: 15px;
}

.news-content img {
  width: 180px;
  height: 120px;
  object-fit: contain;
  border-radius: 6px;
}

.news-info {
  flex: 1;
}

.news-info h2 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #333;
}

.news-info p {
  color: #666;
  margin-bottom: 8px;
  font-size: 17px;
  line-height: 1.6;
}

.news-info .date {
  color: #999;
  font-size: 14px;
}

.read-more {
  color: #1890ff;
  text-decoration: none;
  font-size: 14px;
}

.read-more:hover {
  text-decoration: underline;
}

.expanded-content {
  margin-top: 20px;
  padding: 30px;
  border-top: 1px solid #eee;
  background-color: #fafafa;
  border-radius: 12px;
  color: #333;
  line-height: 1.8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.expanded-content h2 {
  color: #1890ff;
  margin: 30px 0 20px 0;
  font-size: 22px;
  font-weight: 600;
  border-left: 4px solid #1890ff;
  padding-left: 20px;
  position: relative;
}

.expanded-content h2:first-child {
  margin-top: 0;
}

.expanded-content h4 {
  color: #333;
  margin: 25px 0 15px 0;
  font-size: 19px;
  font-weight: 500;
  padding-left: 15px;
  border-left: 3px solid #e6f7ff;
}

.expanded-content h5 {
  color: #555;
  margin: 20px 0 12px 0;
  font-size: 17px;
  font-weight: 500;
  padding-left: 20px;
}

.expanded-content h5 + p {
  margin: 12px 0 12px 40px;
  text-indent: 0;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 3px solid #d6e4ff;
  font-size: 17px !important;
}

.expanded-content p {
  margin: 16px 0;
  color: #666;
  text-align: justify;
  text-indent: 2em;
  line-height: 1.8;
  font-size: 17px !important;
}

/* 确保动态生成的内容也能应用样式 */
.expanded-content div p {
  font-size: 17px !important;
}

.expanded-content div li {
  font-size: 17px !important;
}

.expanded-content ul, .expanded-content ol {
  margin: 20px 0 20px 40px;
  color: #666;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.expanded-content li {
  margin: 12px 0;
  line-height: 1.7;
  padding-left: 10px;
  font-size: 17px !important;
}

@media screen and (max-width: 768px) {
  .news-content {
    flex-direction: column;
    text-align: center;
  }
  .news-content img {
    width: 100%;
    height: auto;
  }
  .news-info h2 {
    font-size: 1.5rem;
  }
  .news-info p {
    font-size: 1.1rem;
  }
  .news-info .date {
    font-size: 1rem;
  }
  .read-more {
    font-size: 1rem;
  }
  .expanded-content {
    font-size: 1.1rem !important;
    padding: 20px;
  }
  
  .expanded-content h2 {
    font-size: 1.2rem;
    padding-left: 15px;
  }
  
  .expanded-content h4 {
    font-size: 1.1rem;
    padding-left: 10px;
  }
  
  .expanded-content h5 {
    font-size: 1rem;
    padding-left: 15px;
  }
  
  .expanded-content h5 + p {
    margin-left: 30px;
    padding: 12px 15px;
  }
  
  .expanded-content ul, .expanded-content ol {
    margin-left: 25px;
    padding: 12px 15px;
  }
}
</style>
